import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link, useSearchParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageUpload from '../../components/ImageUpload';


const AddonForm = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [appLoader, setAppLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [items, setItems] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  

  const [apiData, setApiData] = useState({
    title: "",
    title_ar: "",
    min_selection: "",
    max_selection: "",
    min_quantity: "",
    max_quantity: "",
    item_id: searchParams.get('item_id') || "",
  });


  useEffect(() => {
    if (id) {
      getSingleData();
    }
    // getItemsList();
  }, [id]);

  // useEffect(() => {
  //   getItemsList();
  // }, [search]);

  const getSingleData = async () => {
    try {
      setAppLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `addons/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        const firstMatchingItem = item.items.find(item => 
          item.item_id === apiData.item_id
        );
        setApiData({
          title: item.title,
          title_ar: item.title_ar,
          pos_id: item.pos_id,
          item_id: apiData.item_id,
          min_quantity: firstMatchingItem?.min_quantity,
          max_quantity: firstMatchingItem?.max_quantity,
          min_selection: firstMatchingItem?.min_selection,
          max_selection: firstMatchingItem?.max_selection,
          sort_order: firstMatchingItem?.sort_order,
        });
        
       
      } else {
        toast.error(data.message);
      }
      setAppLoader(false);
    } catch (error) {
      setAppLoader(false);
      console.log(error);
    }
  };


  const getItemsList = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `items-list`,
        data:{search}
      });
      const data = response.data;
      if (data.status) {
        setItems(data.data);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.log(error);
    }
  };
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setApiData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  
  const handleImageChange = (name, file) => {
    setApiData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };


  const submitForm = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const formData = new FormData();
      Object.entries(apiData).forEach(([key, value]) => {
          formData.append(key, value);
      });
      console.log(formData);
      // formData.append("old_image", apiData.old_image);

      const response = await ApiService.request({
        method: 'POST',
        url:  `addons/createOrUpdate/${id || ''}`,
        data:formData
      });
     
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        // navigate("/addons");
        navigate(-1);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error("Submit failed:", error);
      setIsLoader(false);
    }
  };



  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? "Edit" : "Add New"} Modifier Group
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to={-1} className="text-muted text-hover-primary">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to={-1} className="text-muted text-hover-primary">
                  Modifiers
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form
                id="kt_modal_new_target_form"
                encType="multipart/form-data"
                method="POST"
                className="form fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={submitForm}
              >
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Title"
                      required
                      value={apiData.title}
                      name="title"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title Arabic</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Title Ar"
                      required
                      value={apiData.title_ar}
                      name="title_ar"
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div class="col-md-3 fv-row fv-plugins-icon-container">
									        <label class="required fs-6 fw-semibold mb-2 text-info">Min Selection </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Min Selection" name="min_selection" min="0"  value={apiData.min_selection}
                          onChange={handleChange}/>
                  </div>
                  <div class="col-md-3 fv-row fv-plugins-icon-container" id="maxField">
                      <label class="required fs-6 fw-semibold mb-2 text-info">Max Selection </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Max Selection" name="max_selection" min={apiData.min_selection}  value={apiData.max_selection}
                          onChange={handleChange} />
                  </div>
                  <div class="col-md-3 fv-row fv-plugins-icon-container">
									        <label class="required fs-6 fw-semibold mb-2 text-info">Min Quantity </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Min Quantity" name="min_quantity" min="0"  value={apiData.min_quantity}
                          onChange={handleChange}/>
                  </div>
                  <div class="col-md-3 fv-row fv-plugins-icon-container" id="maxField">
                      <label class="required fs-6 fw-semibold mb-2 text-info">Max Quantity </label>
                      <input type="number" required class="form-control form-control-solid" placeholder="Enter Max Quantity" name="max_quantity" min={apiData.min_quantity}  value={apiData.max_quantity}
                          onChange={handleChange} />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2 text-info">Display Order</label>
                    <input
                      type="number"
                      className="form-control form-control-solid"
                      placeholder="Enter Addon Display Order"
                      required
                      value={apiData.sort_order}
                      name="sort_order"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-3">
                        <span> Image</span>
                      </label>
                      <ImageUpload name="image" onImageChange={handleImageChange} defaultPreviewUrl={apiData.image} />
                      
                  </div>
               
                </div>
              

                {/* Form Actions */}
                <div className="row g-9 my-3">
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      {isLoader ? (
                        <Loader size="20" text="Submitting" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddonForm;
